export const setGateways = (config) => ({
    type: 'SET_GATEWAYS',
    payload: config
});